import React from "react";
import "./CommonMessageModal.css";

const CommonMessageModal = ({ show, onClose, message, buttonText = "OK" }) => {
  if (!show) return null;

  return (
    <div className="common-message-overlay">
      <div className="common-message-card">
        <p className="common-message-text">{message}</p>
        <button className="common-message-btn" onClick={onClose} type="button">
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default CommonMessageModal;
